import React from 'react';
import { TertiaryButtonLink, TertiaryButtonLinkProps } from './tertiary-button-link';
import { useTranslation } from 'react-i18next';
import { ContactType } from '../../slices/types';
import { autoId } from '@workday/upc-common';
import { ID_RESET_PASSWORD_EMAIL_OTP, ID_RESET_PASSWORD_SMS_OTP } from '../../autoIds';

export interface AlternativeContactLinkProps extends Omit<TertiaryButtonLinkProps, 'children'> {
    contactType: ContactType;
}

export function AlternativeContactLink({ contactType, ...rest }: AlternativeContactLinkProps) {
    const { t } = useTranslation('auth');

    const messages: Record<ContactType, string> = {
        phone: t('AlternativeContactLink.tryWithSMS'),
        email: t('AlternativeContactLink.tryWithEmail')
    };

    return (
        <TertiaryButtonLink
            {...rest}
            {...autoId(contactType === 'email' ? ID_RESET_PASSWORD_EMAIL_OTP : ID_RESET_PASSWORD_SMS_OTP)}>
            {messages[contactType]}
        </TertiaryButtonLink>
    );
}
